import type { RouteObject } from 'react-router';
import { DevicesPage } from './pages/devices-page';

export const devicesRoutes: RouteObject[] = [
  { path: 'devices', element: <DevicesPage /> },
];
